import React from 'react';
import styles from './index.module.scss';
import VideoSwiper from './components/VideoSwiper';
import { videos } from '@/config/config';

export default function Index() {
  return (
    <div>
      <div className={`${styles.banner} ${styles.top_banner}`}>
        <img
          className={styles.banner_img}
          src="/images/top_banner.jpg"
          alt="banner"
        />
      </div>
      <VideoSwiper videos={videos} />
      <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
    </div>
  )
}
